// extracted by mini-css-extract-plugin
export default {"trade-count":"_1nDxx","tradeCount":"_1nDxx","download-icon":"_2xg0V","downloadIcon":"_2xg0V","resell-button-wrapper":"_3zkf5","resellButtonWrapper":"_3zkf5"};